import api from '../api/axiosConfig';

export const vacanciesApi = {
    getList: async (skip = 0, limit = 20, org_id, filters = {}) => {
        let response;
        const params = { skip, limit, ...filters };

        if (org_id === 'all') {
            response = await api.get('/vacancies/list', {
                params,
                silent: true
            });
        } else {
            response = await api.get('/vacancies/list', {
                params: { ...params, org_id },
                silent: true
            });
        }
        // Возвращаем и items, и total_pages, и total_items из ответа бэкенда
        return {
            items: response.data.data.items,
            total_pages: response.data.data.total_pages,
            total_items: response.data.data.total_items
        };
    },

    getById: async (id, orgId) => {
        const response = await api.get(`/vacancies/${id}`, {
            silent: true
        });
        return response.data;
    },

    create: async (orgId, vacancy) => {
        const response = await api.post(`/vacancies/create?org_id=${orgId}`, vacancy, {
            loadingMessage: 'Создание вакансии...',
            successMessage: 'Вакансия успешно создана'
        });
        return response.data;
    },

    update: async (id, orgId, vacancy) => {
        const response = await api.put(`/vacancies/${id}?org_id=${orgId}`, vacancy, {
            loadingMessage: 'Обновление вакансии...',
            successMessage: 'Вакансия успешно обновлена'
        });
        return response.data;
    },

    delete: async (id) => {
        const response = await api.delete(`/vacancies/${id}`, {
            loadingMessage: 'Удаление вакансии...',
            successMessage: 'Вакансия успешно удалена'
        });
        return response.data;
    },

    getHistory: async (id, organisationId) => {
        const response = await api.get(`/vacancies/${id}/history?org_id=${organisationId}`, {
            silent: true
        });
        return response.data.data;
    },

    getVacanciesFunnelStatuses: async () => {
        const response = await api.get("/vacancy_funnel_statuses/", {
            silent: true
        });
        return response.data.data;
    },

    getVacancyFunnelStatusesById: async (id) => {
        const response = await api.get(`/vacancies/${id}/allowed-funnel-statuses`, {
            silent: true
        });
        return response.data.data;
    },

    addVacancyFunnelStatus: async (id, funnelStatus) => {
        const response = await api.post(`/vacancies/${id}/allowed-funnel-statuses`, funnelStatus, {
            loadingMessage: 'Добавление статуса воронки...',
            successMessage: 'Статус воронки успешно добавлен'
        });
        return response.data;
    },

    updateVacancyFunnelStatus: async (id, funnelStatus) => {
        const response = await api.put(`/vacancies/${id}/allowed-funnel-statuses`, funnelStatus, {
            loadingMessage: 'Обновление статуса воронки...',
            successMessage: 'Статус воронки успешно обновлён'
        });
        return response.data;
    },

    getVacanciesByIds: async (vacancies_ids) => {
        const response = await api.post(`/vacancies/get_vacancies_by_ids`, { vacancies_ids: vacancies_ids }, {
            silent: true
        });
        return response.data.data;
    },
};
